const initialState = {
    statusPage: window.location.pathname,
};
const navigation = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_STATUS_PAGE_NAVIGATION':
            return {...state, statusPage: action.statusPage};
        default:
            return state;
    }
};

export default navigation;